import { render, staticRenderFns } from "./UserDetails_Section_TopRankedTags.vue?vue&type=template&id=25d980fc&"
import script from "./UserDetails_Section_TopRankedTags.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Section_TopRankedTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports